'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactModal = require('react-modal');
var _reactModal2 = _interopRequireDefault(_reactModal);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var modalStyle = {
  overlay: {
    backgroundColor: 'rgba(85, 85, 85, 0.8)'
  }
};

/**
 * Wrapper component on top of React-Modal NPM module.
 */

var ModalDialogBase = function (_React$Component) {
  _inherits(ModalDialogBase, _React$Component);
  function ModalDialogBase() {
    _classCallCheck(this, ModalDialogBase);
    return _possibleConstructorReturn(this, (ModalDialogBase.__proto__ || Object.getPrototypeOf(ModalDialogBase)).apply(this, arguments));
  }
  _createClass(ModalDialogBase, [{
    key: 'render',
    value: function () {
      function render() {
        // check if zIndex is set.
        var zIndex = null;
        if (typeof this.props.zIndex == 'number') {
          zIndex = this.props.zIndex;
        }
        if (zIndex != null) {
          this.modalStyle.overlay.zIndex = zIndex;
        }
        return _react2['default'].createElement(_reactModal2['default'], {
          isOpen: this.props.isOpen,
          shouldCloseOnOverlayClick: false,
          style: modalStyle,
          className: this.props.className,
          contentLabel: 'Modal',
          ariaHideApp: false
        }, this.props.children);
      }
      return render;
    }()
  }]);
  return ModalDialogBase;
}(_react2['default'].Component);
exports['default'] = ModalDialogBase;